import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const getStatsData = async (businessId, startDate, tillDate) => {
  try {
    let resp = await http.get(
      `${URL}/dashboard/${businessId}?startDate=${startDate}&endDate=${tillDate}`
    );
    return resp;
  } catch (error) {
    console.log("error in", error);
    return errorHandler(error);
  }
};
